import dayjs from 'dayjs';

export const getContractInfoDueDateBadgeValue = (
  dueDate: Date | string | null | undefined
): string => {
  if (!dueDate) return '';

  const parsedDueDate = dayjs(dueDate);
  if (!parsedDueDate.isValid()) return '';

  return parsedDueDate.hour(17).minute(0).second(0).millisecond(0).format('YYYY-MM-DDTHH:mm:ss');
};
